import { Loading } from "components/loading";
import LayoutDashboard from "layouts/LayoutDashboard";
import React from "react";

const PageLoading = () => {
	return (
		<>
			<div className="flex-1 flex justify-center items-center h-ful pb-52">
				<Loading></Loading>
			</div>
		</>
	);
};

export default PageLoading;
